/*
  notifyBrevo — dispara un correo transaccional vía el endpoint SSR del sitio
  público (Astro): POST https://surreal.travel/api/notify.

  Migración EmailJS -> Brevo (jul 2026). Antes el admin enviaba desde el browser
  con `emailjs.send(serviceID, templateID, templateParams, userID)` usando el
  user_id PÚBLICO de EmailJS. Brevo NO tiene clave pública, así que el envío se
  mueve a servidor: este helper POSTea { template, params } al endpoint /api/notify,
  que resuelve destinatario/remitente/reply-to y llama a Brevo con la api-key
  (secreta, nunca en el browser). El endpoint ya autoriza el origen
  admin.surreal.travel por CORS (mismo patrón que /api/capi).

  Semántica igual a emailjs.send: RESUELVE en éxito (con la respuesta JSON) y
  LANZA en fallo, para que los try/catch y los encadenamientos `&&` existentes
  se comporten idénticos.

  Firma: notifyBrevo(templateID, templateParams) — mismos nombres de plantilla
  (template_id) que EmailJS.
*/

// IMPORTANTE: usar el host canonico CON www. `surreal.travel` (sin www) hace
// un 308 redirect a www, y los navegadores NO siguen redirects en el preflight
// CORS: el OPTIONS al non-www devuelve el 308 sin cabeceras CORS, el navegador
// aborta el POST, y el envio falla en silencio (lo traga el try/catch). El www
// responde el preflight con 204 + Access-Control-Allow-Origin correcto.
const NOTIFY_ENDPOINT = "https://www.surreal.travel/api/notify";

export async function notifyBrevo(template, params) {
  const res = await fetch(NOTIFY_ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ template: template, params: params || {} }),
  });
  if (!res.ok) {
    let detail = "";
    try {
      detail = await res.text();
    } catch (e) {
      /* ignore */
    }
    throw new Error("notify " + res.status + ": " + detail);
  }
  return res.json().catch(function () {
    return { ok: true };
  });
}

export default notifyBrevo;
